import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import HotelBiGridOptionsBase from './hotel-bi-grid-options-base';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const { bingadsGridColumn } = globalContext.require('component/bingads-grid/shared/column');


export default class HotelDateGridOptions extends HotelBiGridOptionsBase {
  constructor({
    view, gridName, dateFilterContainer, p$daterange, filterService, preferenceService,
  }) {
    const columnsPrev = ['Date'];

    super({
      view,
      gridName,
      dateFilterContainer,
      columnsPrev,
      p$daterange,
      filterService,
      preferenceService,
    });

    this.columns.unshift(bingadsGridColumn({
      name: 'Date',
      title: i18n.getString('HotelCenter_Overview_Grid_Date_Label'),
      sortable: true,
      filterable: true,
      type: 'DayTime',
      property: 'Date',
      template: (local) => {
        if (_.isEmpty(local.value)) {
          return '';
        }

        return i18n.formatDate(new Date(local.value));
      },
    }));

    this.plugins.columnChooser.categories[0].options.unshift({
      key: 'Date',
      name: this.i18n.getString('HotelCenter_Overview_Grid_Date_Label'),
      selectOption: 'locked',
    });
  }
}
